import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { ADD_MARKETING_HISTORY, MARKETING_ROOT } from "./Business.constants";

const MarketingRoot = Loadable(
  lazy(() =>
    import("./MarketingRoot").then(({ MarketingRoot }) => ({
      default: MarketingRoot,
    }))
  )
);
const AddMarketingHistory = Loadable(
  lazy(() =>
    import(
      "./Marketing/AddMarketing/AddMarketingHistory"
    ).then(({ AddMarketingHistory }) => ({ default: AddMarketingHistory }))
  )
);
export const MarketingRoutes = [
  {
    path: `${MARKETING_ROOT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <MarketingRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${ADD_MARKETING_HISTORY}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <AddMarketingHistory />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${ADD_MARKETING_HISTORY}/:marketingHistNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <AddMarketingHistory />
      </AuthorizedRoute>
    ),
  },
];
